<!-- template v.1 -->
<template>
<div class="col py-3">

            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Marcaciones de Empleados </h4>
    
            </div>
  
             <div class="col-md-12" style="padding:0">
            <!-- Profile Image -->
            <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Filtros</h3>
                
              </div>
              <div class="card-body">
              <div class="col-md-12">
                  <div class="col-md-4 form-org">
                       <div class="form-group ">
                  <label class="col-form-label" >
                    Local</label
                  >
                  <select class="form-control"    v-model="Local" @click="CargaReloj()">
                    <option value="-1" >Todos </option>
                    <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                <div class="form-group ">
                  <label class="col-form-label" >
                    Reloj</label
                  >
                  <select class="form-control"    v-model="Reloj">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Relojes" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                  </div>
                  <div class="col-md-4 form-org">
                       <div class="form-group">
                  <label class="col-form-label" >
                    Área</label
                  >
                  <select class="form-control"   v-model="Area">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                <div class="form-group">
                  <label class="col-form-label" >
                    Estado</label
                  >
                  <select class="form-control"  v-model="Estado">
                     <option value="-1"  >Todos </option>
                    <option v-for="item in Parametros" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                  </div>
                  <div class="col-md-4 form-org">
                    <div class="input-group">
                    <label class="col-form-label" style="width: 100%;">
                    DNI
                    </label>
                    <input type="number"
                    class="form-control"
                    @keypress="MaxNumber($event)"
                    pattern="^[0-9]+"
                    oninput="validity.valid||(value='');"
                    v-model="DNI"
                    placeholder="XXXXXXXXX" 
                    onwheel="this.blur()"
                    step="1-9"
                    min="0"
                    max="99999999"
                    autocomplete="off">
                </div>
                <div class="input-group mb-3">
                    <label class="col-form-label"  style="width: 100%;">
                    Nombres
                    </label>
                    <input type="text" class="form-control" maxlength="50" v-model="Nombres" placeholder="Nombres" >
                    
                </div>
                  </div>
              </div>
             
               
               
               
                <div class="col-md-4 form-org">
                <div class="input-group">
                   <button type="submit" 
                   class="btn btn-success" 
                   style="width:100%" 
                   @click="Buscar()" >
                   
                   Buscar</button>
                </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
           
          

      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;margin-bottom: 60px;">
          
          
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th >Código</th>
                      <th >DNI</th>
                      <th >Nombre Completo</th>
                      <th >Área</th>
                      <th >Reloj</th>
                      <th >Local</th>
                      <th >Estado</th>
                      <th >Marcaciones</th>
                   
                     
                    </tr>
                  </thead>
                  
                  <!-- <tbody v-for="(item, index) in ListaEmpleados.filter(Paginador)"   v-bind:key="item" v-bind:index="index" v-show="(pag - 1) * NUM_RESULTS <= index  && pag * NUM_RESULTS > index"> -->
                     <tbody v-for="(item, index) in ListaEmpleados"   v-bind:key="item" v-bind:index="index" >
                    <!--  <tr v-if="!item.disabled"> -->
                      <tr >
                      <td >{{item.nCodigo}}</td>
                      <td >{{item.sDni}}</td>
                      <td >{{item.sNombre}}</td>
                      <td >{{item.sArea}}</td>
                      <td >{{item.sReloj}}</td>
                      <td >{{item.sLocal}}</td>
                      <td >{{item.sEstadoDesc}}</td>
                      <td ><button type="button" class="btn btn-info btn-table" @click="Marcaciones(item)">Ver</button></td>


                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPage(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPages" :key="index" v-show="Math.abs(pageNumber - currentPage) <= 5  || pageNumber == totalPages || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPage(pageNumber)" :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
                <!--<nav aria-label="Page navigation" class="text-center;">
                  <ul class="pagination pagination-sm " style="margin-bottom: 0px;float:right">
                    <li class="page-item">
                      <a href="#" aria-label="Previous" class="page-link" v-show="pag != 1" @click.prevent="pag -= 1">
                        <span aria-hidden="true">Anterior</span>
                      </a>
                    </li>
                    <li class="page-item" style="margin-right:0">
                      <a href="#" aria-label="Next" class="page-link" v-show="pag * NUM_RESULTS / Empleados.filter(Paginador).length < 1" @click.prevent="pag += 1">
                        <span aria-hidden="true">Siguiente</span>
                      </a>
                    </li>
                  </ul>
                </nav>
                -->
        </div>
</div>    
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {
      Locales:[],
      Areas:[],
      Relojes:[],
      Parametros:[],
      Local:-1,
      Area:-1,
      Reloj:-1,
      Estado:1,
      alertax:false,
      DNI:"",
      Nombres:"",
      Empleados:[],
      ListaEmpleados:[],
      itemsPageDefault : 10,
      resultCount: 0,
      currentPage: 0,
      

      
    };
  },
  computed: {
        totalPages: function() {
          return Math.ceil(this.resultCount / this.itemsPageDefault)
        }
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarLocales?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Locales = response.data.oListaLocales;
        })
    
    this.axios
        .get(gestion + "/ListarAreas?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Areas = response.data.oListaAreas;
        })
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Parametros = response.data.oListaParametros;
        })
    
  },
  methods: {
    Marcaciones(item){
        this.$router.push({name: 'marcaciones-empleados', query: {id: item.nCodigo, nombre :item.sNombre}});
        },
    Buscar(){
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarEmpleados?nLocal="+this.Local+"&nReloj="+this.Reloj+
        "&nArea="+this.Area+"&nEstado="+this.Estado+"&sNombre="+this.Nombres+"&sDni="+this.DNI, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Empleados = response.data.oListaEmpleados;
          const countUser = this.Empleados.filter(resp => !resp.disabled);
          this.resultCount = countUser.length;
          this.currentPage = 0;
          if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
          }
          var index = this.currentPage * this.itemsPageDefault;      
          this.ListaEmpleados = this.Empleados.slice(index,index+this.itemsPageDefault);

          
        })

    
    },
     setPage: function(pageNumber) {
            this.currentPage = pageNumber;
 
        
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
                
            }
            var index = (this.currentPage - 1) * this.itemsPageDefault;
            this.ListaEmpleados = this.Empleados.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefault);
        },
    CargaReloj(){
    const Reloj = this.Local;
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarRelojes?nCodigo="+ Reloj, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Relojes = response.data.oListaRelojes;
        })
    },
    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Su DNI debe contar con 8 dígitos',
          icon: 'error',
          
          });
            evt.preventDefault();
          }
    },
    
   
        

  },
}
</script>
